import React from "react";

import SponsorAvatar1 from "../../assets/sponsors/1.png";
import SponsorAvatar2 from "../../assets/sponsors/2.png";
import SponsorAvatar3 from "../../assets/sponsors/3.png";
import SponsorAvatar4 from "../../assets/sponsors/4.png";
import SponsorAvatar5 from "../../assets/sponsors/5.png";
import SponsorAvatar6 from "../../assets/sponsors/6.png";

const Sponsors = () => {
  return (
    <div className="flex flex-col items-center relative z-10 md:gap-24 sm:gap-20 gap-16">
      <div className="flex flex-col gap-8 items-center">
        <span className="font-semibold text-sm text-warning leading-5 uppercase">
          partners
        </span>
        <p className="font-semibold md:text-5xl text-4xl text-center text-dark leading-tight">
          Supported by:
        </p>
      </div>
      
      <div className="w-full flex flex-wrap lg:justify-between justify-center items-center">
        <div onClick={() => window.open("https://www.openmined.org/", "_blank")} className="cursor-pointer lg:w-fit md:w-1/3 sm:w-1/2 w-full mb-6">
          <img src={SponsorAvatar1} className="mx-auto" />
        </div>
        <div onClick={() => window.open("https://opendp.org/", "_blank")} className="cursor-pointer lg:w-fit md:w-1/3 sm:w-1/2 w-full mb-6">
          <img src={SponsorAvatar2} className="mx-auto" />
        </div>
        <div onClick={() => window.open("https://www.harvard.edu/", "_blank")}  className="cursor-pointer lg:w-fit md:w-1/3 sm:w-1/2 w-full mb-6">
          <img src={SponsorAvatar3} className="mx-auto" />
        </div>
        <div onClick={() => window.open("https://www.oblivious.ai/", "_blank")} className="cursor-pointer lg:w-fit md:w-1/3 sm:w-1/2 w-full mb-6">
          <img src={SponsorAvatar4} className="mx-auto" />
        </div>
        <div onClick={() => window.open("https://research.ibm.com/labs/europe/", "_blank")} className="cursor-pointer lg:w-fit md:w-1/3 sm:w-1/2 w-full mb-6">
          <img src={SponsorAvatar5} className="mx-auto w-48 opacity-60" />
        </div>
        <div onClick={() => window.open("https://www.microsoft.com/", "_blank")} className="cursor-pointer lg:w-fit md:w-1/3 sm:w-1/2 w-full mb-6">
          <img src={SponsorAvatar6} className="mx-auto" />
        </div>
      </div>
    </div>
  );
};

export default Sponsors;
